import { getPropertyValue } from "../../common/util/changeUtils.jsx";
import { getTimeLeftSeconds } from "../../common/util/time.js";
import moment from "moment";

/**
 * Returns true if active order can be edited
 * @param {object} activeOrder 
 * @returns {bool}
 */
export function canWorkWithOrder(activeOrder) {
    //must be time left
    const sLeft = activeOrder.customerDeadlineDate ? getTimeLeftSeconds(activeOrder.customerDeadlineDate) : 1;
    //must have an order
    //must have an active shipment selected
    return activeOrder && (activeOrder.shipmentId!=null || activeOrder.myListId!=null || activeOrder.bagSupplier!=null || activeOrder.bagNumber!=null || activeOrder.claim!=null) && !activeOrder.submitting && sLeft>0;
}

/**
 * Returns true if this list is using CounterFields
 * @param {object} activeObj
 * @returns {func}
 */
export function usingCounterField(activeObj){
    //TODO: find a nicer method to get what type of input field to use
    const lines = getPropertyValue(activeObj,"lines");
    if( lines ) {
        return lines.length>0 && lines[0].wishedQtySalesUnits!=null;
    }
    return true;
}

export const countWhat = {
    everything: "everything",
    ordered: "ordered",
    unConfirmed: "unConfirmed",
};

/**
 * Returns how many of a specific product that is added in the active order
 * @param {object} activeObj 
 * @param {string} productId
 * @param {string} counting    //if we should only count ordered items
 * @param {number} salesLineId   
 * @returns {func}
 */
export function countAddedProduct(activeObj, productId, counting, salesLineId){
    let count = null;
    if( activeObj.unConfirmedOrderLines && (counting===countWhat.everything || counting===countWhat.unConfirmed)) {
        //add togheter all unconfirmed order lines
        for(let i=0; i<activeObj.unConfirmedOrderLines.length; i++) {
            const line = activeObj.unConfirmedOrderLines[i];
            if( line.productId === productId && ((salesLineId === undefined || salesLineId === null) || salesLineId === line.salesLineId)) {
                count = (count==null?0:count)+line.orderedQty;
            }
        }
        if( count!=null ) {
            return count || 0;
        }
    }
    if( activeObj.orderLines && (counting===countWhat.everything || counting===countWhat.ordered)) {
        //add togheter all confirmed order lines
        for(let i=0; i<activeObj.orderLines.length; i++) {
            const line =activeObj.orderLines[i];
            if( line.productId === productId  && (((salesLineId === undefined || salesLineId === null) && !line.isKitMember) || salesLineId === line.salesLineId) ) {
                count = (count==null?0:count)+line.orderedQty;
            }
        }
        //can only exist with value > 0
        if( count!=null ) {
            return count || 0;
        }
    }
    
    const lines = getPropertyValue(activeObj,"lines");
    if( lines ) {
        //set value equal to wishedQtySalesUnits or 1. if wishedQtySalesUnits then it is tobacco otherwise it is in "editing my list"
        for(let i=0; i<lines.length; i++) {
            if( lines[i].product.productId === productId ) {
                count = lines[i].wishedQtySalesUnits || 1;
            }
        }
    } else if(activeObj.bagSupplier){
        //loop all suppliers
        for(let i=0; i<activeObj.bagSupplier.length; i++){
            const bagSupplier = activeObj.bagSupplier[i];
            //we only count whats in the last bag
            const j=bagSupplier.bags.length-1;
            const bags = bagSupplier.bags[j];
            //loop all lines
            for(let k=0; k<bags.lines.length; k++){
                const line = bags.lines[k];
                if( line.product.productId === productId ) {
                    return line.wishedQtySalesUnits;
                }
            }
        }
    }
    return count || 0;
}
/**
 * Returns a parameter from orderd/unConfirmed lines. 
 * @param {object} activeOrder
 * @param {string} productId
 * @param {string} property
 * @param {number} salesLineId
 * @returns {func}
 */
export function getProductOrderProperty(activeOrder, productId, property, salesLineId){
    //The productId will only occure once in either unConfirmedOrderLines or orderLines
    //

    //active order contains more data, and should be checked first
    if( activeOrder.orderLines) {
        for(let i=0; i<activeOrder.orderLines.length; i++) {
            const product=activeOrder.orderLines[i];
            if( product.productId === productId &&(((salesLineId === undefined || salesLineId === null) && !product.isKitMember) || product.salesLineId === salesLineId)) {
                //check if it is part of the line
                if( product[property] ){
                    return product[property];
                }
                //check if it is part of the product information
                if( product.product && product.product[property] ) {
                    return product.product[property];
                }
                //return null;
            }
        }
    }
    if( activeOrder.unConfirmedOrderLines) {
        for(let i=0; i<activeOrder.unConfirmedOrderLines.length; i++) {
            if( activeOrder.unConfirmedOrderLines[i].productId === productId ) {
                //check if it is part of the line
                if( activeOrder.unConfirmedOrderLines[i][property] ){
                    return activeOrder.unConfirmedOrderLines[i][property];
                }
                //check if it is part of the product information
                if( activeOrder.unConfirmedOrderLines[i].product && activeOrder.unConfirmedOrderLines[i].product[property] ) {
                    return activeOrder.unConfirmedOrderLines[i].product[property];
                }
                return null;
            }
        }
    }
    return null;
}

/**
 * Returns salesLineId if it is in orderLines
 * @param {object} activeObj 
 * @param {string} productId
 * @param {bool} noKitMember
 * @returns {func}
 */
export function getSalesLineId(activeObj, productId, noKitMember){
    if( activeObj.orderLines) {
        for(let i=0; i<activeObj.orderLines.length; i++) {
            if( activeObj.orderLines[i].productId === productId && activeObj.orderLines[i].salesLineId!=null  && (!noKitMember ||  !activeObj.orderLines[i].isKitMember)) {
                return activeObj.orderLines[i].salesLineId;
            }
        }
    }
    return undefined;
}

/**
 * Returns time left in seconds, or if time has passed it reeturns 0
 * @param {string} dateStr 
 * @returns {func}
 */
export function getProgressForOrderDate(dateStr) {
    if(dateStr && dateStr.length>0){
        const eventTime = moment(dateStr).unix();
        const currentTime = moment().unix();
        const diffTime = eventTime - currentTime;
        if( diffTime>0 ) {
            const duration = moment.duration(diffTime * 1000, "milliseconds");
            const h = moment.duration(duration).hours() + (moment.duration(duration).days()*24);
            const m = moment.duration(duration).minutes();
            const s = moment.duration(duration).seconds();
            const sLeft = (h*3600) + (m*60) + s;
            return Math.max(0.0, 1.0-((sLeft>24*3600)?0.0:1.0-sLeft/(24*3600)));
        }
    }
    return 0;
}

/**
 * Returns Number of unique lines in the order
 * @param {object} activeOrder 
 * @returns {number}
 */
export function countOrderLines(activeOrder) {
    let count = activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.length;
    //count rows if they are not in unConfirmedOrderLines
    if( activeOrder.orderLines) {
        for(let i=0; i<activeOrder.orderLines.length; i++) {
            const prdId = activeOrder.orderLines[i].productId;
            count += (activeOrder.unConfirmedOrderLines && activeOrder.unConfirmedOrderLines.some( (item) => item.productId===prdId )) ? 0 : 1;
        }
    }
    return count;
}